"use client";

import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";
import { PiCheckCircle } from "react-icons/pi";

export default function CorporatePricing({
  content,
  onContentChange,
  isSelected,
}: SectionContentProps) {
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const plans = content.plans || [
    { name: "Starter", price: "49", period: "/mo", desc: "For small teams", features: ["5 Users", "Basic Analytics", "Standard Support"], buttonText: "Choose Starter", link: "#" },
    { name: "Enterprise", price: "299", period: "/mo", desc: "For large companies", features: ["Unlimited Users", "Advanced Security", "24/7 Phone Support"], buttonText: "Choose Enterprise", link: "#" }
  ];

  return (
    <section
      className={`py-24 px-6 bg-slate-50 text-slate-800 transition-all ${isSelected ? "ring-2 ring-blue-500 relative z-20" : ""}`}
      style={{ fontFamily }}
    >
      <div className="max-w-7xl mx-auto space-y-12">
        <div className="text-center space-y-4 max-w-xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 leading-tight">
            <EditableText
              value={content.title || "Flexible Pricing Plans"}
              onChange={(val) => onContentChange?.({ ...content, title: val })}
              as="span"
            />
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
          {plans.map((plan: any, idx: number) => (
            <div key={idx} className="bg-white p-8 rounded-2xl border border-slate-200 space-y-6 flex flex-col justify-between shadow-sm hover:shadow-md transition-all">
              <div className="space-y-4">
                <h3 className="text-xl font-bold text-blue-600">{plan.name}</h3>
                <div className="flex items-baseline">
                  <span className="text-4xl font-extrabold text-slate-900">${plan.price}</span>
                  <span className="text-slate-500 text-sm ml-1">{plan.period}</span>
                </div>
                <p className="text-slate-500 text-sm">{plan.desc}</p>
                <ul className="space-y-2 pt-2">
                  {plan.features?.map((feat: string, fIdx: number) => (
                    <li key={fIdx} className="flex items-center gap-2 text-sm text-slate-600">
                      <PiCheckCircle className="w-4 h-4 text-blue-600 flex-shrink-0" />
                      <span>{feat}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="pt-6">
                <a
                  href={plan.link || "#"}
                  className="block text-center py-2.5 rounded-lg bg-blue-650 hover:bg-blue-700 text-white font-bold text-sm transition-all"
                >
                  {plan.buttonText || "Choose Plan"}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
